import { Check, ChevronDown } from 'lucide-react';
import { Badge, type BadgeVariant } from './Badge';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from './DropdownMenu';

export interface StatusOption {
  value: string;
  label: string;
  tone: BadgeVariant;
}

/** Допустимые переходы задаёт владелец данных, отмену — его ToastProvider. */
export function StatusControl({
  value,
  options,
  transitions,
  onChange,
  disabled,
}: {
  value: string;
  options: readonly StatusOption[];
  transitions?: readonly string[];
  onChange: (value: string) => void;
  disabled?: boolean;
}) {
  const current = options.find((o) => o.value === value);
  const next = options.filter((o) => o.value !== value && (!transitions || transitions.includes(o.value)));
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-slot="status-control"
          disabled={disabled || next.length === 0}
          aria-label={`Статус: ${current?.label ?? value}`}
          className="inline-flex items-center gap-1 rounded-full py-1 focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none disabled:cursor-default disabled:opacity-70"
        >
          <Badge solid variant={current?.tone ?? 'neutral'}>
            {current?.label ?? value}
          </Badge>
          <ChevronDown className="size-3 text-fg-subtle" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuLabel>Изменить статус</DropdownMenuLabel>
        {next.map((option) => (
          <DropdownMenuItem key={option.value} leftIcon={<Check />} onSelect={() => onChange(option.value)}>
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
